<script setup>
import Heading from '@sections/home/heading.vue'
import Button from '@components/global/button.vue'
import { formatDate } from '@utils/date'
import { useNewsStore } from '@stores/news'
const news = useNewsStore()
</script>
<template>
	<div class="bg-bg-light">
		<section class="container">
			<Heading>
				<template #title>articles</template>
				<template #text>Excepteur do minim eu ad eu anim quis qui elit non ullamco.</template>
				<template #button>
					<Button class="btn-outline" :to="{ name: 'articles' }">go to blog</Button>
				</template>
			</Heading>
			<div class="flex flex-col gap-10 md:flex-row">
				<div class="hidden w-full flex-col justify-end md:flex md:w-half">
					<img class="absolute-y-center -left-[20%] hidden md:block" src="https://hennep.s3.amazonaws.com/above/images/home/articles/ufo.png" alt="" />

					<Button class="btn-outline w-fit" :to="{ name: 'articles' }">go to blog</Button>
				</div>
				<div class="mt-4 flex min-h-[400px] w-full flex-col gap-6 overflow-hidden md:mt-10 md:w-half">
					<img class="absolute -right-[60%] bottom-[0%] hidden -rotate-45 mix-blend-screen md:block" src="https://hennep.s3.amazonaws.com/above/images/home/products/aurora.png" alt="" />
					<template v-for="(article, index) in news.articles" :key="article.id">
						<Button class="flex items-center gap-4 md:gap-8" :to="{ name: 'article', params: { slug: article.slug } }">
							<div class="flex flex-1 flex-col gap-6">
								<div class="flex flex-col gap-4">
									<div class="flex items-center gap-2">
										<div class="flex items-center gap-3">
											<div class="h-1.5 w-1.5 bg-text-base"></div>
											<div class="font-body text-body-sm font-medium uppercase tracking-wider text-text-base">
												{{ formatDate(article.published_at) }}
											</div>
										</div>
									</div>
									<div class="font-heading text-h4 font-semibold uppercase text-text-base">
										{{ article.title }}
									</div>
								</div>
							</div>
						</Button>
						<svg v-if="index < news.articles.length - 1" xmlns="http://www.w3.org/2000/svg" width="1344" height="2" viewBox="0 0 1344 2" fill="none">
							<path d="M0 1H1344" stroke="white" stroke-opacity="0.2" stroke-width="1.5" stroke-dasharray="2 6" />
						</svg>
					</template>
				</div>
				<div class="block w-fit self-center md:hidden">
					<Button class="btn-outline" :to="{ name: 'articles' }">go to blog</Button>
				</div>
			</div>
		</section>
	</div>
</template>
<style scoped></style>
